<div class="notification-wrapper" (click)="onNotificationClick()">
  <div class="notification-txt">
    <span class="txt">{{ item.Body }}</span>
  </div>
  <div class="notification-date">{{ item.Created | agencyDate }}</div>
  <div class="close-wrapper">
    @if (!pending) {
    <remove-button
      class="close-btn"
      [colorClassName]="iconColors.GREY"
      [disabled]="pending"
      [noCrossMargin]="true"
      [transparentBackground]="true"
      (onClick)="deleteNotification($event)"
    >
    </remove-button>
    } @if (pending) {
    <spinner class="no-pad" size="xs"></spinner>
    }
  </div>
</div>
